<template>
  <div>
    <div>
      <div class="content-header container-fluid bg-white">
        <div class="row">
          <div class="col-sm-4">
            <h4><i class="ti-shield"></i> 安全巡检 | 巡检统计</h4>
          </div>
          <div class="col-sm-8" style="text-align: right;margin-top: 10px">
            <button type="submit" class="el-button el-button--success" @click="$router.back()">
              <span>返回</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content">
        <el-tabs v-model="activeName"  type="border-card">
          <el-tab-pane v-for="item in type.ls" :key="item.ID" :label="item.Safe_Class_Name" :name="item.Safe_Class_Name">
          </el-tab-pane>
          <keep-alive>
            <AF v-if="activeName=='安全巡检'" :type="type.ls.find(item=>item.Safe_Class_Name==activeName)"></AF>
            <XF v-if="activeName=='消防巡检'" :type="type.ls.find(item=>item.Safe_Class_Name==activeName)"></XF>
          </keep-alive>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import AF from "./AF.vue"
import XF from "./XF.vue"
export default {
  name: "index",
  components: { AF,XF},
  data() {
    return {
      activeName:"安全巡检",
      type: {
        ls: []
      }
    }
  },
  created() {
    this.getType();
  },
  methods: {
    getType() {
      let self = this;
      this.whale.remote.getCollection({
        url: '/api/School/SAFE/SafeClassConfig/GetPageList',
        completed(its) {
          self.type.ls = JSON.parse(JSON.stringify(its));
        }
      })
    },
  }
}
</script>